module.exports = __webpack_public_path__ + "5cca4bf30884ce429ac05483d0441514.png";